export const COUNTRIES = [
    { code: 'BE', name: 'Belcika', phone: '+32' },
    { code: 'TR', name: 'Turkiye', phone: '+90' },
    { code: 'DE', name: 'Almanya', phone: '+49' },
    { code: 'FR', name: 'Fransa', phone: '+33' },
    { code: 'NL', name: 'Hollanda', phone: '+31' },
    { code: 'GB', name: 'Ingiltere', phone: '+44' },
    { code: 'IT', name: 'Italya', phone: '+39' },
    { code: 'ES', name: 'Ispanya', phone: '+34' },
    { code: 'AT', name: 'Avusturya', phone: '+43' },
    { code: 'CH', name: 'Isvicre', phone: '+41' },
    { code: 'PL', name: 'Polonya', phone: '+48' },
    { code: 'US', name: 'ABD', phone: '+1' },
    { code: 'LU', name: 'Luksemburg', phone: '+352' },
    { code: 'SE', name: 'Isvec', phone: '+46' },
    { code: 'DK', name: 'Danimarka', phone: '+45' },
    { code: 'NO', name: 'Norvec', phone: '+47' },
    { code: 'PT', name: 'Portekiz', phone: '+351' },
    { code: 'GR', name: 'Yunanistan', phone: '+30' },
    { code: 'RO', name: 'Romanya', phone: '+40' },
    { code: 'BG', name: 'Bulgaristan', phone: '+359' },
];

export const PHONE_CODES = COUNTRIES.map(c => ({ code: c.phone, name: c.name }));
